export default "__VITE_ASSET__CWYGOBIr__"